import { createFileRoute } from "@tanstack/react-router";
import MarblePavers from "@/pages/MarblePavers";
import { buildHead } from "@/lib/seo";

const OG_IMAGE =
  "https://vibe.filesafe.space/1779750798598342338/attachments/6cd7a94c-c25b-4556-9358-95411c8e61cf.png";

export const Route = createFileRoute("/marble-pavers")({
  head: () =>
    buildHead({
      title:
        "Luxury Marble Pavers for Pool Decks & Patios | Precision Pavers & Pool Design",
      description:
        "Explore our exclusive collection of luxury natural marble pavers for pool decks, patios, driveways, and outdoor living spaces in South Florida. Free estimates.",
      path: "/marble-pavers",
      ogImage: OG_IMAGE,
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "Product",
          name: "Luxury Marble Pavers Collection",
          description:
            "Natural stone marble pavers in various shades, sizes, and textures for luxury pool deck and patio installations.",
          brand: {
            "@type": "Brand",
            name: "Precision Pavers & Pool Design",
          },
          offers: {
            "@type": "AggregateOffer",
            priceCurrency: "USD",
            availability: "https://schema.org/InStock",
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://precisionpaverspools.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Marble Pavers",
              item: "https://precisionpaverspools.com/marble-pavers",
            },
          ],
        },
      ],
    }),
  component: MarblePavers,
});
